<template>
  <entity-edit-form
    :title="title"
    :data-service="dataService"
    :create-entity="isCreate"
    :fields="fields"
    :list-route-name="listRouteName"
    :item-id="this.$route.params.id"
  >
    <template #field.contractSignDate="{item}">
      <read-only-text-field
        :class="item.contractSignDate ? 'color-green' : 'color-red'"
        label="Дата подписания договора"
        :value="formatContractSignDate(item.contractSignDate)"
      />
    </template>
  </entity-edit-form>
</template>

<script>
  import EntityEditForm from '@/components/ui/crud/EntityEditForm.vue'
  import ReadOnlyTextField from '@/components/ui/crud/fields/ReadOnlyTextField.vue'
  import OrganizationDataService from '@/services/api/OrganizationDataService'
  import { VCheckbox, VTextField } from 'vuetify/lib'

  export default {
    components: { EntityEditForm, ReadOnlyTextField },
    data () {
      return {
        title: 'Редактирование организации (юр-лица)',
        isCreate: false,
        listRouteName: 'organizationsList',
        dataService: OrganizationDataService,
        fields: [
          { key: 'name', label: 'Название', component: VTextField, defaultValue: null, rules: ['required'] },
          { key: 'contractSignDate' },
          { key: 'jupiterName', label: 'Название в Юпитер', component: VTextField, rules: [], defaultValue: null },
          { key: 'inn', label: 'ИНН', component: VTextField, defaultValue: null },
          { key: 'kpp', label: 'КПП', component: VTextField, defaultValue: null },
          { key: 'phone', label: 'Телефон', component: VTextField, defaultValue: null },
          { key: 'email', label: 'Email', component: VTextField, defaultValue: null, rules: ['email'] },
          { key: 'status', label: 'Организация активна (статус)', component: VCheckbox, defaultValue: true },
        ],
      }
    },
    methods: {
      formatContractSignDate (contractSignDate) {
        if (!contractSignDate) {
          return 'Договор не подписан'
        }

        return new Date(contractSignDate).toLocaleDateString(this.$i18n.locale, {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })
      },
    },
  }
</script>
